import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { Icon } from 'components/styled/icon'
import { BodyStyle } from 'components/styled/typography/styles'
import { Flex } from 'components/styled/containers/flex'
import { I18nComponentType } from 'i18n/i18n-types'

interface NavigationBarProps {
  i18n: I18nComponentType
  dispatch: any
  locationState: { pathname: string }
  className?: string
  children?: React.ReactNode | React.ReactNode[]
  routePrefix?: string
  actionBackText?: string
  leftActions?: boolean
  language?: string
}

const mapStateToProps = (state: any) => ({
  locationState: state.routing.locationBeforeTransitions,
})

const StyledBackLink = styled.div`
  ${BodyStyle};
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.color.white};
  font-weight: 400;
  cursor: pointer;
`

const StyledNav = styled.nav`
  display: flex;
  position: relative;
  height: ${({ theme }) => theme.space.s40};
  padding: ${({ theme }) => theme.space.s8};
  justify-content: space-between;
  background-color: ${({ theme }) => theme.color.blackO30};
  z-index: 10;
`

const NavBarContainer = styled.div`
  height: 0;
  max-width: 100vw;
`

export const NavigationBar = ({
  actionBackText,
  routePrefix,
  className = 'navigation-bar',
  children,
  i18n,
  leftActions = true,
  dispatch,
  locationState,
  language,
}: NavigationBarProps) => {
  const classes = [className]

  const { pathname } = locationState
  const prefixPath = routePrefix ? `${routePrefix}/` : ''

  return (
    <NavBarContainer>
      <StyledNav className={classes.join(' ')}>
        <Flex alignItems="center" justifyContent="flex-start">
          {leftActions && pathname !== prefixPath && (
            <StyledBackLink onClick={() => dispatch(push(prefixPath))}>
              <Icon
                type={
                  language && language === 'ar'
                    ? 'chevron_right'
                    : 'chevron_left'
                }
                color="white"
              />
              {actionBackText || i18n.navigationBar.frontpage}
            </StyledBackLink>
          )}
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          {children}
        </Flex>
      </StyledNav>
    </NavBarContainer>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  NavigationBar
)
